// Módulo para interacciones con la API de Ines
class InesAPI {
  constructor() {
    this.baseUrl = 'https://ssttbeca.ines.cl/ssttbeca';
  }

  // Consultar orden existente
  async consultarOrden(orderNumber) {
    const formData = new FormData();
    formData.append('ot', orderNumber);
    
    const response = await fetch(`${this.baseUrl}/consulta.php`, {
      method: 'POST',
      body: formData
    });
    
    const text = await response.text();
    return this.parseResponse(text);
  }

  // Crear nueva orden
  async crearOrden(orderData) {
    // Extraer imágenes antes de serializar
    const productImage = orderData.productImage || '';
    const boletaImage = orderData.boletaImage || '';
    
    // Crear copia sin imágenes para el JSON
    const dataWithoutImages = { ...orderData };
    delete dataWithoutImages.productImage;
    delete dataWithoutImages.boletaImage;
    
    const formData = new FormData();
    formData.append('data', JSON.stringify(dataWithoutImages));
    formData.append('email', orderData.email);
    formData.append('productImage', productImage);
    formData.append('boletaImage', boletaImage);
    
    console.log('INES-API: Enviando productImage:', productImage ? `${productImage.length} bytes, inicia con: ${productImage.substring(0, 50)}` : 'vacía');
    console.log('INES-API: Enviando boletaImage:', boletaImage ? `${boletaImage.length} bytes, inicia con: ${boletaImage.substring(0, 50)}` : 'vacía');
    
    // Verificar que FormData tiene las imágenes
    console.log('INES-API: FormData keys:', Array.from(formData.keys()));
    console.log('INES-API: productImage en FormData:', formData.get('productImage') ? `${formData.get('productImage').length} bytes` : 'vacía');
    console.log('INES-API: boletaImage en FormData:', formData.get('boletaImage') ? `${formData.get('boletaImage').length} bytes` : 'vacía');
    
    const response = await fetch(`${this.baseUrl}/registro.php`, {
      method: 'POST',
      body: formData
    });
    
    const text = await response.text();
    return this.extractOrderInfo(text);
  }

  // Actualizar estado de orden
  async actualizarEstado(ordenId, estado) {
    const updateData = {
      orden_id: ordenId,
      estado: estado
    };

    const response = await fetch(`${this.baseUrl}/update.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateData)
    });
    
    return response.text();
  }

  // Parsear respuesta de consulta
  parseResponse(text) {
    try {
      return JSON.parse(text);
    } catch (jsonError) {
      // Intentar limpiar y parsear
      try {
        const cleaned = text.replace(/\\n/g, "\\n")
          .replace(/\\'/g, "\\'")
          .replace(/\\"/g, '\\"')
          .replace(/\\&/g, "\\&")
          .replace(/\\r/g, "\\r")
          .replace(/\\t/g, "\\t")
          .replace(/\\b/g, "\\b")
          .replace(/\\f/g, "\\f")
          .replace(/[\u0000-\u0019]+/g, "");
        return JSON.parse(cleaned);
      } catch (error) {
        throw new Error('La respuesta del servidor no pudo ser procesada');
      }
    }
  }

  // Extraer información de orden de la respuesta
  extractOrderInfo(text) {
    console.log('INES-API: Respuesta completa de INES:', text);
    
    let ordenId = "GENERADO";
    let pdfUrl = "";
    
    // Buscar URL del PDF
    const urlPdfMatch = text.match(/https?:\/\/[^"\s]+pdfProducto\.php\?ticket=[0-9]+/);
    if (urlPdfMatch) {
      pdfUrl = urlPdfMatch[0].replace(/\\\//g, '/');
      console.log('INES-API: PDF URL encontrada:', pdfUrl);
    }
    
    // Buscar código BECA (patrón principal)
    const cobaMatch = text.match(/COBATFDV([0-9]+)/i);
    if (cobaMatch) {
      ordenId = "COBATFDV" + cobaMatch[1];
      console.log('INES-API: Código BECA encontrado:', ordenId);
      return { ordenId, pdfUrl };
    }
    
    // Buscar solo números (ticket)
    const ticketMatch = text.match(/ticket[=:]?\s*([0-9]+)/i);
    if (ticketMatch) {
      ordenId = ticketMatch[1];
      console.log('INES-API: Ticket encontrado:', ordenId);
      return { ordenId, pdfUrl };
    }
    
    // Otros patrones de búsqueda
    const patronesBusqueda = [
      /[Cc][Óóo][Dd][Ii][Gg][Oo](?:\s+)[Bb][Ee][Cc][Aa][:=\s]+([A-Za-z0-9]+)/i,
      /orden\s+(?:n[uú]mero\s+)?([0-9A-Za-z]+)/i,
      /generada.*?([0-9]{6,})/i,
      /id[=:]\s*['"]?([0-9A-Za-z]+)['"]?/i,
      /([0-9]{8,})/
    ];
    
    for (const patron of patronesBusqueda) {
      const coincidencia = text.match(patron);
      if (coincidencia && coincidencia[1]) {
        ordenId = coincidencia[1];
        console.log('INES-API: ID encontrado con patrón:', ordenId);
        break;
      }
    }
    
    console.log('INES-API: Orden ID final:', ordenId);
    return { ordenId, pdfUrl };
  }
}

// Instancia global
window.inesAPI = new InesAPI();